import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

import {
    FL_IMAGE, FL_INCLUDE, FL_LONG_DESCRIPTION, FL_NOTE, FL_RECOMENDATION, FL_SHORT_DESCRIPTION,
    FL_TITLE,
    FL_WARNING
} from "../../../components/i18n/formLabels";
import {
    PH_IMAGE, PH_INCLUDE,
    PH_LONG_DESCRIPTION,
    PH_NOTE,
    PH_RECOMENDATION,
    PH_SHORT_DESCRIPTION,
    PH_TITLE,
    PH_WARNING
} from "../../../components/i18n/placeHolders";
import {LB_URL_VIDEO} from "../../../components/i18n/i18n";

import {LangController} from "../../../components/tabs/langController";
import MarkdownInput from "../../../components/inputs/MarkdownInput";

const ActivityLangs = props => {

    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            note:'',
            include:'',
            image:'',
            title:'',
            warning:'',
            recomendation:'',
            longDescription:'',
            shortDescription:'',
            videoUrl    : '',
            noteMax:'',
            warningMax:'',
            recomendationMax:'',
            slogan: '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="8">
                <FormGroup>
                    <MarkdownInput
                        label={FL_TITLE}
                        type="textarea"
                        name="title"
                        placeholder={PH_TITLE}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>{FL_IMAGE}</Label>
                    <Input
                        type="text"
                        name="image"
                        placeholder={PH_IMAGE}
                        value={ child.image }
                        onChange={ ({target:{name, value}}) => onInputChange(name,value,child?.lang) }
                        disabled={ disableInputs }
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>{LB_URL_VIDEO}</Label>
                    <Input
                        type="text"
                        name="videoUrl"
                        placeholder={LB_URL_VIDEO}
                        value= { child.videoUrl }
                        onChange={ ({target:{name, value}}) => onInputChange(name,value,child?.lang) }
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={'Slogan'}
                        type="textarea"
                        name="slogan"
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={FL_SHORT_DESCRIPTION}
                        placeholder={PH_SHORT_DESCRIPTION}
                        type="textarea"
                        name="shortDescription"
                        rows={'3'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <MarkdownInput
                        label={FL_LONG_DESCRIPTION}
                        placeholder={PH_LONG_DESCRIPTION}
                        type="textarea"
                        name="longDescription"
                        rows={'10'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>

            <Col md="6">
                <FormGroup>
                    <MarkdownInput
                        label={FL_WARNING}
                        placeholder={PH_WARNING}
                        type="textarea"
                        name="warning"
                        rows={'10'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <MarkdownInput
                        label={FL_RECOMENDATION}
                        placeholder={PH_RECOMENDATION}
                        type="textarea"
                        name="recomendationMax"
                        rows={'10'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <MarkdownInput
                        label={FL_INCLUDE}
                        placeholder={PH_INCLUDE}
                        type="textarea"
                        name="include"
                        rows={'10'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={FL_NOTE}
                        placeholder={PH_NOTE}
                        type="textarea"
                        name="note"
                        rows={'4'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>


    return <LangController
        markdown={true}
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default ActivityLangs